module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/BattlesButton/images/normal.6fdfe789.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/BattlesButton/images/normal.png
// module id = 3063
// module chunks = 11